import { RefObject, useEffect, useState } from 'react';

export function useMouse<T extends HTMLElement>(ref: RefObject<T>, isMouseDown: boolean) {
  const [isMouseInElement, setIsMouseInElement] = useState(false)
  const [mouseLeaveEvent, setMouseLeaveEvent] = useState<MouseEvent | null>(null);
  useEffect(() => {
    function onMouseLeave(e: MouseEvent) {
      setIsMouseInElement(false)
      setMouseLeaveEvent(e)
    }
    function onMouseEnter(e: MouseEvent) {
      setIsMouseInElement(true)
      setMouseLeaveEvent(null)
    }
    if (ref.current && isMouseDown) {
      ref.current.addEventListener('mouseout', onMouseLeave)
      ref.current.addEventListener('mouseenter', onMouseEnter)
    }
    return () => {
      ref.current?.removeEventListener('mouseout', onMouseLeave)
      ref.current?.removeEventListener('mouseenter', onMouseEnter)
    }
  }, [ref.current, isMouseDown])
  return {
    isMouseInElement,
    mouseLeaveEvent,
  }
}
